import { ReactNode } from "react";
import classNames from "classnames";
import QuestionMarkTooltip from "components/QuestionMarkTooltip/QuestionMarkTooltip";

interface CardProps {
  children: ReactNode;
  header?: ReactNode;
  tooltip?: string;
  onClick?: () => void;
  id?: string;
  center?: boolean;
}

export const Card = ({ children, header, onClick, id, tooltip }: CardProps) => (
  <div
    id={id}
    className={classNames(
      "flex overflow-hidden flex-col w-full h-full bg-white rounded-lg border shadow-md",
      {
        "cursor-pointer": !!onClick,
      }
    )}
    onClick={onClick}
  >
    {header && (
      <div className="p-2 md:px-4 flex flex-row items-center gap-1 text-2xl font-bold bg-powderBlue-700">
        {header}
        {tooltip && (
          <div className="text-sm font-normal">
            <QuestionMarkTooltip tooltipContent={tooltip} id={id + "tooltip"} />
          </div>
        )}
      </div>
    )}
    {children}
  </div>
);
